import MUIAddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import {
  styled,
  buttonClasses,
  Badge as MUIBadge,
  Button as MUIButton,
} from "@mui/material";

type SharedProps = {
  hasFiltersApplied?: boolean;
  canRemove?: boolean;
};

export const Button = styled(MUIButton, {
  shouldForwardProp: (prop) => prop !== "hasFiltersApplied",
})<SharedProps>(({ theme, hasFiltersApplied }) => ({
  height: "32px", // <<-- Adjusted height from original copy for better alignment
  padding: "4px 8px",
  color: hasFiltersApplied
    ? theme.palette.primary.main
    : theme.palette.grey[500],
  border: hasFiltersApplied
    ? `1px solid ${theme.palette.grey[500]}`
    : `1px dashed ${theme.palette.grey[500]}`,
  "&:hover": {
    background: theme.palette.grey[100],
  },
  [`.${buttonClasses.startIcon}`]: {
    marginRight: 4,
  },
}));

export const AddCircleOutlineIcon = styled(MUIAddCircleOutlineIcon, {
  shouldForwardProp: (prop) => prop !== "canRemove",
})<SharedProps>(({ theme, canRemove }) => ({
  transform: `rotate(${canRemove ? "45deg" : "0deg"})`,
  transition: "all linear 0.2s",
  color: theme.palette.grey[500],
  "&:hover": {
    color: canRemove ? theme.palette.error.main : theme.palette.primary.main,
  },
}));

export const Badge = styled(MUIBadge)(({ theme }) => ({
  marginLeft: 4,
  marginRight: 8,
  "& .MuiBadge-badge": {
    minWidth: "14px",
    height: "14px",
    fontSize: "8px",
    fontWeight: 600,
    padding: "2px",
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
}));
